import { Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const Main = styled.main<{ src?: string }>`
  display: flex;
  margin-left: 300px;
  flex-direction: column;
  flex: 1 0 0;
  padding: 32px 64px 64px;
  align-items: center;
  gap: 32px;
  height: 100vh;
  min-height: 100vh;
  background-image: url('/images/bg-horizontal.png'), linear-gradient(to bottom, rgba(28, 28, 28, 1) 70%, #151515 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: top, top;
  background-size: 100% auto, 100% 100%;
  overflow-y: auto;

  @media (max-width: 1280px) {
    gap: 16px;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    padding-bottom: 50px;
    background-image: url('/images/bg-vertical.png');
    background-size: 100% 100%;
  }
`

export const Body = styled.div`
  display: flex;
  // max-width: 1280px;
  padding-top: 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  @media (max-width: 1280px) {
    padding-top: 16px;
  }

  @media (max-width: 768px) {
    padding-top: 0;
  }
`

export const PageHeader = styled.div`
  display: flex;
  padding: 16px 0px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-bottom: 20px;

  @media (max-width: 930px) {
    flex-direction: column;
  }
`
export const PageHeaderTitle = styled.span`
  color: #fff;
  text-align: right;
  font-family: Newake;
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 57.6px */
`
export const Touchable = styled(Flex)`
  cursor: pointer;
  white-space: nowrap;
  gap: 5px;
  transition: 0.5s ease;
  &:hover {
    opacity: 0.8;
  }
`

export const SpinnerWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  align-self: stretch;
  height: 100vh;
`
